<template lang="pug">
.card.personal-data(
    :class="{ 'card--expand': isProgressState, 'card--done': isFinishedState }"
  )

    .loader-content(v-if="isLoading" class="loader-content__fixed z-999")
      cp-loader(text="Aguarde! Estamos carregando seus dados para você concluir a transação.")

    .card__head
      .titleStep
        cp-icon.titleStep__icon(v-if="!hasMobile" path="/icons/user.svg")
        h3.titleStep__title {{ titleStep }}

      .btnEdit(v-if="isFinishedState && !hasMobile" @click="openStep")
        cp-icon.btnEdit__icon(path='/icons/edit.svg')
        span.btnEdit__label Editar

    .card__body.personal-data__container(:class="expandContent")
      .personal-data__row
        cp-field(
          label="Nome completo"
          for="name"
          id="name"
          type="text"
          name="name"
          placeholder="Ex: João Oliveira da Silva"
          transform="captalize"
          :value="name"
          :validation="nameValidation"
          @change="setName"
        )
        cp-field.personal-data__row__fieldBirthday(
          v-if="isShowField('birthday')"
          label="Data de Nascimento"
          for="birthday"
          id="birthday"
          type="tel"
          name="birthday"
          placeholder="Somente números"
          :disabled="product.isRenovation"
          :mask="['##/##/####']"
          :value="birthday"
          :validation="birthdayValidation"
          @change="setBirthday"
        )
        cp-field.personal-data__row__fieldGender(
          label="Gênero"
          for="gender"
          id="gender"
          name="gender"
          is-select
          :options="genderOptions"
          :value="gender"
          :validation="genderValidation"
          @change="setGender"
        )
      .personal-data__row
        cp-field(
          label="CPF"
          for="cpf"
          id="cpf"
          type="tel"
          name="cpf"
          placeholder="Somente números"
          :disabled="product.isRenovation"
          :mask="['###.###.###-##']"
          :value="cpf"
          :validation="cpfValidation"
          @change="setCpf"
        )
        cp-field(
          label="Celular"
          for="cellphone"
          id="cellphone"
          type="tel"
          name="cellphone"
          placeholder="Somente números"
          :mask="['(##) #####-####']"
          :value="cellphone"
          :validation="cellphoneValidation"
          @change="setCellphone"
        )
      .personal-data__row
        cp-field(
          label="E-mail"
          for="email"
          id="email"
          className="lowercase"
          type="email"
          name="email"
          :value="email"
          :validation="emailValidation"
          @change="setEmail"
        )
        cp-field(
          label="Confirme o e-mail"
          for="checkEmail"
          id="checkEmail"
          className="lowercase"
          type="email"
          name="checkEmail"
          :disabled="$v.email.$invalid"
          :value="checkEmail"
          :validation="checkEmailValidation"
          @change="setCheckEmail"
        )
      .personal-data__row(
        v-if="estateOwnerField"
      )
        cp-field(
          :label="estateOwnerField.label"
          :for="estateOwnerField.for"
          :id="estateOwnerField.id"
          :name="estateOwnerField.name"
          :type="estateOwnerField.type"
          :options="estateOwnerField.options"
          :value="personalData[estateOwnerField.value]"
          @change="setEstateOwner"
        )

      TermsAccept(v-if="hasLead" @acceptedTerms="getAcceptedTerms")

      .personal-data__row
        cp-button.btn__nextStep(
          label="Continuar"
          size="medium"
          :disabled="isbtnDisabled"
          @onClick="nextStep"
        )
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'

import moment from 'moment'
import { map, filter } from 'lodash'
import { CPF } from 'cpf_cnpj'
import { helpers, minLength, required, email, numeric, sameAs } from 'vuelidate/lib/validators'

import views from '@/mixins/views'
import dataLayer from '@/utils/data-layer'
import { PROGRESS_STATE, FINISHED_STATE } from '@/stateSteps'

import CpLoader from '@/components/molecules/Loader.vue'
import CpIcon from '@/components/atoms/Icon.vue'
import CpField from '@/components/molecules/Field.vue'
import CpButton from '@/components/atoms/Button.vue'
import TermsAccept from '@/components/atoms/TermsAccept.vue'

export default {
  name: 'CustomerPersonalData',
  mixins: [views],
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hasMobile: '',
      isAcceptedTerms: false,
      hasLead: false
    }
  },
  components: {
    CpLoader,
    CpIcon,
    CpField,
    CpButton,
    TermsAccept
  },
  created () {
    if (this.personalData.name) {
      this.$nextTick(function () {
        document.getElementById('birthday') &&
          document.getElementById('birthday').focus()
      })
    }

    if (this.product?.params?.app_nolead) {
      this.hasLead = true
      this.isAcceptedTerms = true
    }

    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  computed: {
    ...mapState(['isLoading', 'product', 'personalData', 'steps']),
    expandContent () {
      return {
        'personal-data__container--expand': this.steps.personalData === PROGRESS_STATE || this.hasMobile
      }
    },
    isProgressState () {
      return this.steps.personalData === PROGRESS_STATE || this.hasMobile
    },
    isFinishedState () {
      return this.steps.personalData === FINISHED_STATE
    },
    titleStep () {
      return (this.product.personalData && this.product.personalData.title) || 'Dados Pessoais'
    },
    name () {
      return this.personalData.name
    },
    birthday () {
      return this.personalData.birthday
    },
    cpf () {
      return this.personalData.cpf
    },
    cellphone () {
      return this.personalData.cellphone
    },
    email () {
      return this.personalData.email.toLowerCase()
    },
    checkEmail () {
      return this.personalData.checkEmail.toLowerCase()
    },
    estateOwner () {
      return this.personalData.estateOwner
    },
    gender () {
      return this.personalData.gender
    },
    genderOptions () {
      return [
        {
          value: 'M',
          label: 'Masculino'
        },
        {
          value: 'F',
          label: 'Feminino'
        },
        {
          value: 'O',
          label: 'Outros'
        }
      ]
    },
    nameValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Informe seu nome e sobrenome',
          valid: false
        }
      ]

      if (!this.$v.name.$invalid) return { valid: true }
      if (!this.$v.name.blackListName) return validations[0]
      if (this.$v.name.$dirty && this.$v.name.$invalid) return validations[0]

      return {}
    },
    cpfValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Informe seu CPF',
          valid: false
        },
        {
          type: 'error',
          msg: 'CPF Inválido',
          valid: false
        },
        {
          msg: 'Verificando CPF...'
        }
      ]

      if (!this.$v.cpf.$invalid && this.cpf.length === 11) return { valid: true }
      if (this.$v.cpf.$dirty && this.$v.cpf.$invalid) {
        if (!this.$v.cpf.required) return validations[0]
        if (!this.$v.cpf.cpfValidator && this.$v.cpf.required) return validations[1]
        if (this.$v.cpf.cpfValidator && this.$v.cpf.$pending) return validations[2]
      }

      return {}
    },
    birthdayValidation () {
      if (!this.$v.birthday) return

      const validations = [
        {
          type: 'error',
          msg: 'Data inválida',
          valid: false
        },
        {
          type: 'error',
          msg: 'Você precisa ser maior de 18 anos',
          valid: false
        },
        {
          type: 'error',
          msg: 'Informe sua data de nascimento',
          valid: false
        }
      ]

      if (!this.$v.birthday.$invalid && this.birthday.length === 8 && !this.$v.birthday.isLessThan1Day) return { valid: true }
      if (this.$v.birthday.$invalid && this.$v.birthday.$dirty) {
        if (!this.$v.birthday.isLessThan1Day) return validations[0]
        if (this.birthday.length === 0) return validations[3]
        if (!this.$v.birthday.date && this.birthday.length > 0) return validations[0]
        if (!this.$v.birthday.isGreaterThen18Years) return validations[1]
      }

      return {}
    },
    cellphoneValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Informe um telefone',
          valid: false
        },
        {
          type: 'error',
          msg: 'Informe um telefone válido',
          valid: false
        }
      ]

      if (!this.$v.cellphone.$invalid && this.cellphone.length >= 10) return { valid: true }
      if (this.$v.cellphone.$dirty) {
        if (!this.$v.cellphone.required) return validations[0]
        if (this.$v.cellphone.$invalid) return validations[1]
      }

      return {}
    },
    emailValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Por favor, insira um e-mail',
          valid: false
        },
        {
          type: 'error',
          msg: 'Por favor, insira um e-mail válido',
          valid: false
        }
      ]

      if (!this.$v.email.$invalid) { return { valid: true } }
      if (this.$v.email.$dirty && !this.$v.email.required) return validations[0]
      if ((this.$v.email.$dirty && this.$v.email.$invalid) || !this.$v.email.email) return validations[1]

      return {}
    },
    checkEmailValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Informe um e-mail',
          valid: false
        },
        {
          type: 'error',
          msg: 'Os emails informados não conferem',
          valid: false
        }
      ]

      if (!this.$v.checkEmail.$invalid && this.$v.checkEmail.sameAsEmail) { return { valid: true } }
      if (this.$v.checkEmail.$dirty && !this.$v.checkEmail.required) return validations[0]
      if (this.$v.checkEmail.$dirty && this.$v.checkEmail.$invalid && !this.$v.checkEmail.sameAsEmail) return validations[1]

      return {}
    },
    genderValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Informe seu gênero',
          valid: false
        }
      ]

      if (!this.$v.gender.$invalid) return { valid: true }
      if (this.$v.gender.$dirty && !this.$v.gender.required) return validations[0]
      return {}
    },
    isbtnDisabled () {
      const isInvalid = this.$v.$invalid || this.isAcceptedTerms
      this.changeValidateStepPersonalData(!isInvalid)
      return isInvalid
    },
    estateOwnerField () {
      const attributes = filter(this.product.customFields, field => {
        return field.step === 'personalData' &&
          filter(field.fields, attr => attr.name === 'name' && attr.value === 'estateOwner')
      })[0]?.fields[0]?.attributes

      if (!attributes) {
        return null
      }

      const field = {}

      map(filter(attributes, attribute => attribute.name), attr => {
        Object.assign(field, {
          [attr.name]: attr.value
        })
      })

      return field
    }
  },
  methods: {
    ...mapMutations('validatedSteps', ['changeValidateStepPersonalData']),
    ...mapMutations('personalData', [
      'changePersonalDataName',
      'changePersonalDataBirthday',
      'changePersonalDataCpf',
      'changePersonalDataCellphone',
      'changePersonalDataEmail',
      'changePersonalDataCheckEmail',
      'changePersonalDataEstateOwner',
      'changePersonalDataGender'
    ]),
    ...mapActions('lead', ['postLeadAction']),
    setName (value) {
      this.setDirty(this.$v.name)
      this.changePersonalDataName(value)
    },
    setBirthday (value) {
      this.setDirty(this.$v.birthday)
      this.changePersonalDataBirthday(value)
    },
    setCpf (value) {
      this.setDirty(this.$v.cpf)
      this.changePersonalDataCpf(value)
    },
    setCellphone (value) {
      this.setDirty(this.$v.cellphone)
      this.changePersonalDataCellphone(value)
    },
    setEmail (value) {
      this.setDirty(this.$v.email)
      this.changePersonalDataEmail(value)
    },
    setCheckEmail (value) {
      this.setDirty(this.$v.checkEmail)
      this.changePersonalDataCheckEmail(value)
    },
    setEstateOwner (value) {
      this.changePersonalDataEstateOwner(value)
    },
    setGender (value) {
      this.changePersonalDataGender(value)
    },
    getAcceptedTerms (value) {
      this.isAcceptedTerms = value
    },
    nextStep () {
      this.steps.personalData = FINISHED_STATE
      this.steps.address = PROGRESS_STATE

      dataLayer({
        event: `${this.product.alias}-semprebem`,
        category: `${this.product.alias}-dados-pessoais`,
        action: 'click',
        label: 'continuar-1'
      })

      // se a jornada for sem lead, chamar api para criar o lead
      if (this.hasLead) {
        // chama o methodo de cadastro lead
        this.createLead()
      }

      this.$router.push({ name: 'address' })
    },
    openStep () {
      this.$router.push({ name: 'personal-data' })

      this.steps.personalData = PROGRESS_STATE
      this.steps.address = this.steps.address !== 'initial' ? 'finished' : 'initial'
      this.steps.payment = this.steps.payment !== 'initial' ? 'finished' : 'initial'
      this.steps.sendQuotation = this.steps.sendQuotation !== 'initial' ? 'finished' : 'initial'
      this.steps.termsAndConditions = this.steps.termsAndConditions !== 'initial' ? 'finished' : 'initial'
    },
    handleResize () {
      this.hasMobile = window.innerWidth < 767 && true
    },
    isShowField (currentField) {
      if (!this.product.personalData || !this.product.personalData.blacklistField) return true

      return !this.product.personalData.blacklistField.some(field => {
        return field === currentField
      })
    },
    async createLead () {
      await this.postLeadAction({
        cookieGa: this.product?.params?._ga,
        data: {
          ...this.product.lead.payload,
          allowTermsUse: 'true',
          leadEmail: this.personalData.email,
          leadName: this.personalData.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(),
          leadPhone: this.personalData.cellphone,
          step: 'Dados Pessoais'
        }
      })
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  validations () {
    const defaultValidation = {
      name: {
        required,
        alphaWhiteDiacritic: helpers.regex('alphaWhiteDiacritic', /^[a-zA-ZÀ-ž.\s]*$/),
        fullName: helpers.regex('fullName', /.{2,}\s.{2,}/),
        blackListName: (value) => !(/((^|\s)((teste|test)(s)?)(\s|$))/i.test(value))
      },
      birthday: {
        required,
        date: value => {
          const date = moment(value, 'DDMMYYYY')
          return date.isValid() && date.year() >= 1900
        },
        isGreaterThen18Years: value => {
          return !moment(value, 'DDMMYYYY').add(18, 'years').isAfter()
        },
        isLessThan1Day: value => {
          return moment(value, 'DDMMYYYY').add(1, 'day').isBefore()
        }
      },
      cpf: {
        required,
        cpfValidator: (value) => CPF.isValid(value)
      },
      cellphone: {
        required,
        numeric,
        minLength: minLength(11),
        isValidCellPhoneNumber: (number) => {
          if (!number) return false
          const { groups } = /(?<areaCode>\d{2})(?<phone>.*)/.exec(number)
          if (/^0/.test(groups.areaCode) || /^[0-8]/.test(groups.phone)) return false
          if (/(.)\1{7,}/.test(groups.phone)) return false
          return true
        }
      },
      email: {
        required,
        validateEmail: helpers.regex('validateEmail', /^[a-zA-Z_0-9._-]+@[a-zA-Z_0-9]+\.[a-zA-Z]+(\.[a-zA-Z]+)?$/),
        blackListEmail: (value) => {
          return ![
            /test(e|s|es)?@test(e|s|es)?\.com(\.br)?/,
            /\.combr$/
          ].some(regexp => regexp.test(value))
        },
        email
      },
      checkEmail: {
        required,
        sameAsEmail: sameAs('email')
      },
      gender: {
        required
      }
    }

    const blacklistField = (this.product.personalData && this.product.personalData.blacklistField) || null
    if (blacklistField && blacklistField.length > 0) {
      blacklistField.forEach(field => delete defaultValidation[field])
    }

    return defaultValidation
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .personal-data {
    &__row {
      width: 100%;

      @media screen and (min-width: 768px) {
        display: flex;
      }

      &__fieldBirthday {
        @media screen and (min-width: 768px) {
          max-width: 200px;
        }
      }
    }

    &__container {
      display: none;

      &--expand {
        display: block;
      }
    }
  }

  .loader-content {
    align-items: center;
    background-color: rgba(#fff, .95);
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    top: 0;
    width: 100%;

    &__fixed {
      position: fixed;
    }
  }
</style>
